import { initScreen } from "config/constants";

export default function cacheMultipleItems(obj) {
  for (let key in obj) {
    const value = obj[key];
    const valueInString = typeof value !== 'string' ? JSON.stringify(value) : value;
    localStorage.setItem(key, valueInString);
  }
};

export function cacheItem(key, value) {
  const valueStringified = typeof value !== 'string' ? JSON.stringify(value) : value;
  localStorage.setItem(key, valueStringified);
};

export function getCachedItem(key) {
  const value = localStorage.getItem(key);
  return JSON.parse(value);
};

export function getInitScreen() {
  const selectedScreen = localStorage.getItem(initScreen);
  return selectedScreen;
};